import util from '@bmp-vue/core/api/util'

const controller = 'Roles'
export default Object.assign({}, util.GetCrud(controller, null), {
  RolesPersist (key, dto) {
    if (!key) { return util.Axios.Post(`${controller}`, dto) }
    return util.Axios.Put(controller, key, dto)
  }
})
